import {useEffect} from 'react';

import {assertAndContinue} from 'Asserts';
import {
  MethodAnalysisSources,
  WorksheetAnalysisSources,
} from 'procedures/design/AssayProcedureMethodAnalysisTypes';
import {
  fetchAssayProcedureMethodDefinitionAnalysisSources,
  fetchAssayProcedureMethodInstanceAnalysisSources,
} from 'procedures/network/AssayProcedureMethodAnalysisDAO';
import useStateIfMounted from 'ui-library/hooks/useStateIfMounted';

export function useAnalysisSourcesDuringConfig(methodId: string | null): MethodAnalysisSources | null {
  const [analysisSources, setAnalysisSources] = useStateIfMounted<MethodAnalysisSources | null>(null);
  useEffect(() => {
    async function fetchAnalysisSources(): Promise<void> {
      if (methodId == null) {
        assertAndContinue(false, 'Expected method id to exist for analysis template source table');
        return;
      }

      const result = await fetchAssayProcedureMethodDefinitionAnalysisSources(methodId);
      setAnalysisSources(result);
    }
    fetchAnalysisSources();
    // Only re-fetch if the method id changes, not setAnalysisSources
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [methodId]);

  return analysisSources;
}

export function useAnalysisSourcesDuringExecution(worksheetId: string): WorksheetAnalysisSources | null {
  const [analysisSources, setAnalysisSources] = useStateIfMounted<WorksheetAnalysisSources | null>(null);
  useEffect(() => {
    async function fetchAnalysisSources(): Promise<void> {
      setAnalysisSources(null);
      if (worksheetId == null) {
        assertAndContinue(false, 'Expected worksheet id to exist for analysis template source table');
        return;
      }

      const result = await fetchAssayProcedureMethodInstanceAnalysisSources(worksheetId);
      setAnalysisSources(result);
    }
    fetchAnalysisSources();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [worksheetId]);

  return analysisSources;
}
